import type {
  CreateQuickViewApiArg,
  ReadInstrumentsApiArg,
  UpdateQuickViewApiArg,
} from 'lib-analytics-types';
import moment from 'moment-timezone';

import { sanitizeHtml } from 'utils/sanitizeHtml';

export function transformReadInstrumentsArg({
  id,
  ...body
}: ReadInstrumentsApiArg): Omit<ReadInstrumentsApiArg, 'id'> {
  return {
    ...body,
    settings: {
      ...body.settings,
      timezone: body.settings?.timezone ?? moment.tz.guess(),
      locale: body.settings?.locale ?? moment.locale(),
    },
    meta: Object.keys(body.meta ?? {}).length ? body.meta : undefined,
  };
}

export function transformCreateUpdateQuickViewArg(
  quickView:
    | CreateQuickViewApiArg['quickView']
    | UpdateQuickViewApiArg['quickView'],
): CreateQuickViewApiArg['quickView'] | UpdateQuickViewApiArg['quickView'] {
  return {
    ...quickView,
    name: sanitizeHtml(quickView.name, 'plainText'),
    ...(quickView.description && {
      description: sanitizeHtml(quickView.description, 'plainText'),
    }),
  };
}
